import { render, staticRenderFns } from "./houtai_jingru.vue?vue&type=template&id=2c6a4066&scoped=true&"
import script from "./houtai_jingru.vue?vue&type=script&lang=js&"
export * from "./houtai_jingru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a4066",
  null
  
)

export default component.exports